<script>
    import router from "page";
    import { onMount } from "svelte";
    import { isLoading, locale } from "../stores.js";

    import { TabulatorFull as Tabulator } from "tabulator-tables";

    import { getLocaleResource } from "../utils/locales.js";

    import { fetchGet } from "../utils/utilsFetch.js";

    import {
        currencyFormatter,
        productPictureLinkFormatter,
        numberFormatter,
        oneDecimalFormatter,
        percentFormatter,
        keywordFilter,
        dateFormatterSimple,
        numberFormatterSimple,
        documentTableColumns,
    } from "../utils/utilsTabulator.js";

    export let invoiceKey;

    let data, tableElement;

    onMount(async () => {
        $isLoading = true;

        data = await fetchGet(`/api/invoices/${invoiceKey}`);

        new Tabulator(tableElement, {
            height: "100%",
            data: data.invoiceItems,
            layout: "fitDataFill",
            vertAlign: "middle",
            columnCalcs: "both",
            columns: documentTableColumns,
        });

        $isLoading = false;
    });
</script>

<div class="container">
    {#if data}
        <div class="header">
            <div>
                <b>{getLocaleResource($locale, "invoice")}:</b>
                {invoiceKey}
            </div>
            <div>
                <b>{getLocaleResource($locale, "date")}:</b>
                {dateFormatterSimple(data.invoice.date)}
            </div>
            <div>
                <b>{getLocaleResource($locale, "total")}:</b>
                {numberFormatterSimple(data.invoice.totalWithVat)} KM
            </div>
            <div>
                <b>{getLocaleResource($locale, "vat")}:</b>
                {numberFormatterSimple(data.invoice.totalVat)} KM
            </div>
            <div>
                <b>{getLocaleResource($locale, "status")}:</b>
                {data.invoice.status}
            </div>
        </div>
    {/if}

    <div class="content">
        <div class="table" bind:this={tableElement} />
    </div>
</div>

<style>
    .container {
        display: grid;
        grid-template-columns: 1fr;
        /* calc sprecuva tabelata da ide nadvor od content*/
        /* grid-template-rows: 30px 45px calc(100vh - 95px);  */
        grid-template-rows: auto 1fr;
        height: 100%;
    }

    .header {
        grid-row: 1/2;

        display: flex;
        flex-wrap: wrap;
        align-items: center;
        /* background: #ccc; */
        padding: 10px;
    }

    .header div {
        margin-right: 20px;
    }

    .content {
        padding: 0px 10px 10px 10px;
        grid-row: 2/-1;

        overflow: auto;
    }
</style>
